<template>
	<div class="title">
		<div class="title-container">
			<h1 class="title2">
				<span v-html="title"></span>
	  		</h1>
  		</div>
	</div>
</template>

<script>

import texts from '@texts/controls.json'

export default {
	name: 'Title',
	data() {
		return {
			title: texts.title,
		}
	}
}
</script>


<style scoped lang="scss">
.title  {
	padding-bottom: 12px;
	width: 100%;
	margin-bottom: 0 !important;


}

.title-container {
	text-align: center;
	width: 100%;
	max-width: 500px;
	margin: 0 auto;

	&:not(:last-child) {
		margin-bottom: 1rem;
	}
/*
	@include from($tablet) {
		max-width: 400px;
	}

	@include from($desktop) {
		max-width: 500px;
	}
	*/
}

.br {
	display: none;
	@include from($desktop) {
		display: block;
	}
}

.title2 {
	@extend %font-title;



	@include from(420px) {
		font-size: 18px !important;
	}

	@include from(500px) {
		font-size: 22px !important;
	}


}
</style>
